<div class="crud-item-page">
  <form [formGroup]="form">
    <div class="crud-item-section">

      <span>
        <mat-form-field matTooltip="Domain" [matTooltipDisabled]="disabledTooltip(this.domain)" class="crud-item-input-wider">
          <mat-label i18n="@@type.RefCode.domain">Domain</mat-label>
          <input matInput [matAutocomplete]="domainAutocomplete" formControlName="domain" maxlength="64"
            id="domainAutocompleteInput" [(ngModel)]="item.domain" (ngModelChange)="domainChanged($event)" #domainInput>
          <mat-autocomplete id="domainAutocomplete" #domainAutocomplete>
            <mat-option *ngFor="let domain of domainSelectionList | async" [value]="domain">
              {{ domain }}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </span>
    
      <span>
        <mat-form-field matTooltip="Code" [matTooltipDisabled]="disabledTooltip(this.code)">
          <mat-label i18n="@@type.RefCode.code">Code</mat-label>
          <input matInput formControlName="code" id="code"              
              (ngModelChange)="codeChanging($event)" [(ngModel)]="item.code"              
              (ngModelChange)="codeChanged($event)" #code              
              maxlength="64" placeholder="Code">
        </mat-form-field>
      </span>

    </div>
    <mat-divider></mat-divider>
  
    <div class="crud-item-section">

      <span>
        <mat-form-field matTooltip="Meaning" [matTooltipDisabled]="disabledTooltip(this.meaning)" class="crud-item-input-wider">
          <mat-label i18n="@@type.RefCode.meaning">Meaning</mat-label>
          <input matInput formControlName="meaning" id="meaning"              
              (ngModelChange)="meaningChanging($event)" [(ngModel)]="item.meaning"              
              (ngModelChange)="meaningChanged($event)" #meaning              
              maxlength="255" placeholder="Meaning">
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Val1" [matTooltipDisabled]="disabledTooltip(this.val1)">
          <mat-label i18n="@@type.RefCode.val1">Val1</mat-label>
          <input matInput formControlName="val1" id="val1"              
              (ngModelChange)="val1Changing($event)" [(ngModel)]="item.val1"              
              (ngModelChange)="val1Changed($event)" #val1              
              maxlength="32" placeholder="Val1">
        </mat-form-field>
      </span>
    
      <span>
        <mat-form-field matTooltip="Val2" [matTooltipDisabled]="disabledTooltip(this.val2)">
          <mat-label i18n="@@type.RefCode.val2">Val2</mat-label>
          <input matInput formControlName="val2" id="val2"              
              (ngModelChange)="val2Changing($event)" [(ngModel)]="item.val2"              
              (ngModelChange)="val2Changed($event)" #val2              
              maxlength="32" placeholder="Val2">
        </mat-form-field>
      </span>

    </div>
    <mat-divider></mat-divider>
  
  </form>
</div>